import $ from 'jquery';
import analytics from '../../services/analytics_service';
import config from '../../config';

export default () => {
    if (config.get('featureFlags.piwikEnabled') === true) {
        analytics.enableHeartBeatTimer();
        analytics.trackContentImpressions();

        const $document = $(document);
        const setUpClickEvents = (conf) => {
            const { selector, name, value } = conf;
            $document.on('click', selector, function () {
                // console.log(name);
                analytics.trackClick(name, value);
            });
        };
        [
            {
                selector: '.hamburger-click-area',
                name: 'hamburger',
                value: document.location.href
            }
        ].forEach(setUpClickEvents);
    }
};
